document.addEventListener("DOMContentLoaded", function () {
  let heroSectionModified = false;
  let myRewardsSectionModified = false;
  let rewardsGuideCloned = false;

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          // Check if it is an element node

          // Hero Section modification
          if (
            !heroSectionModified &&
            node.classList.contains("yotpo-widget-hero-section")
          ) {
            const shopifySection = node.closest(".shopify-section");
            if (
              shopifySection &&
              !shopifySection.classList.contains(
                "shopify-section-yotpo-rewards-hero"
              )
            ) {
              shopifySection.classList.add(
                "shopify-section-yotpo-rewards-hero"
              );
              heroSectionModified = true;
            }
          }

          // My Rewards Section modification
          if (
            !myRewardsSectionModified &&
            node.classList.contains("yotpo-widget-my-rewards-widget")
          ) {
            const shopifySection = node.closest(".shopify-section");
            if (
              shopifySection &&
              !shopifySection.classList.contains(
                "shopify-section-yotpo-rewards-myrewards"
              )
            ) {
              shopifySection.classList.add(
                "shopify-section-yotpo-rewards-myrewards"
              );
              myRewardsSectionModified = true;
            }
          }

          // Create and append Item Step's Numbers
          if (
            node.nodeType === 1 &&
            (node.classList.contains("yotpo-reward-steps-item") ||
              node.querySelector(".yotpo-reward-steps-item"))
          ) {
            // Handle multiple steps items possibly being added
            const stepItems = node.classList.contains("yotpo-reward-steps-item")
              ? [node]
              : node.querySelectorAll(".yotpo-reward-steps-item");
            stepItems.forEach((stepItem) => {
              // Determine which step item it is by class and prepend the appropriate number
              if (stepItem.classList.contains("yotpo-reward-steps-item-1")) {
                prependTextToTitle(stepItem, "01 ");
              } else if (
                stepItem.classList.contains("yotpo-reward-steps-item-2")
              ) {
                prependTextToTitle(stepItem, "02 ");
              } else if (
                stepItem.classList.contains("yotpo-reward-steps-item-3")
              ) {
                prependTextToTitle(stepItem, "03 ");
              }
            });
          }

          // Check if all modifications are done and if so, disconnect the observer
          if (
            heroSectionModified &&
            myRewardsSectionModified &&
            rewardsGuideCloned
          ) {
            observer.disconnect();
            console.log("Observer disconnected after completing all tasks.");
          }
        }
      });
    });
  });

  const config = {
    childList: true,
    subtree: true,
  };

  observer.observe(document.body, config);
});

function prependTextToTitle(stepItem, text) {
  // Find the .yotpo-reward-steps-title within the step item
  const titleDivs = stepItem.querySelectorAll(".yotpo-reward-steps-title");
  titleDivs.forEach((titleDiv) => {
    const textNode = document.createTextNode(text); // Create text node
    titleDiv.prepend(textNode); // Prepend the text node to the title div
  });
}